<template>
  <div class="firm_container">
    <div class="firm_Main_body">
      <!-- 头部导航栏 -->
      <div class="Navigation_con1">
        <NavFirm :navNum="1" @handleWarn="handleWarn"></NavFirm>
      </div>
      <div class="firm-nav-table">
        <div class="nav-left">
          <div class="menu-box">
            <div class="menu-title" @click="goBack">
              <img
                class="title-img"
                src="@/assets/imgs/back-da@3x.svg"
                alt=""
              />
              <span class="title-text">返回首页</span>
            </div>
            <div
              v-for="(item, index) in menuList"
              :key="item.id"
              @click="routerChange(index, item)"
              :class="
                selIndex != index ? 'menu-box-item-yes' : 'menu-box-item-no'
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div
            style="
              width: 1200px;
              min-height: calc(100vh - 60px);
              margin: 0 auto;
              padding-top: 30px;
              box-sizing: border-box;
            "
          >
            <router-view></router-view>
          </div>
          <!-- 账号注销提示弹窗 -->
          <SignOut
            :dialogSignOut="dialogSignOut"
            @handleClose="handleClose"
            @handleUnderstand="handleUnderstand"
          >
          </SignOut>
        </div>
      </div>
    </div>

    <!-- 右侧反馈   客服 -->
    <!-- <div class="right_btn">
            <IndexRight></IndexRight>
          </div> -->
  </div>
</template>

<script>
// 账号注销提示弹窗
import SignOut from "../../personage/home/components/Popup/SignOut.vue";
// 反馈 客服
import IndexRight from "../../../components/IndexRight.vue";
import NavFirm from "../../../components/NavFirm.vue";
export default {
  props: {},
  // 局部注册的组件
  components: {
    NavFirm,
    //IndexRight,
    SignOut,
  },
  // 组件状态值
  data() {
    return {
      scroll: "",
      scrollType: "1",
      searchType: "",
      dialogSignOut: false, // 账号注销弹窗开启关闭
      menuList: [
        {
          name: "职场信用查询",
          url: "/Firm/creditQuery",
          id: 1,
        },
      ],
      selIndex: 0,
    };
  },
  watch: {
    scroll: {
      handler(newss, old) {
        if (newss > 80) {
          this.scrollType = "2";
        } else {
          this.scrollType = "1";
        }
      },
      immediate: false,
    },
    // 监听页面路径
    $route() {
      console.log(this.$route.path);
      if (this.$route.path == "/Firm/creditQuery") {
        this.selIndex = 0;
      }
    },
  },
  // 组件初始化
  created() {
    var currentURL = window.location.href;
    console.log(currentURL);
  },
  // 组件实例挂载完毕
  mounted() {
    // 获取当前页面路径
    let currentUrl = this.$route.path;
    // 判断路径，给selIndex赋值 用于高亮导航菜单当前选中
    if (currentUrl == "/Firm/creditQuery") {
      this.selIndex = 0;
    }
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  // 组件方法
  methods: {
    // 打开账号注销弹窗
    handleWarn() {
      this.dialogSignOut = true;
    },
    // 点击取消x 关闭账号注销提示弹窗
    handleClose() {
      this.dialogSignOut = !this.dialogSignOut;
    },
    // 账号注销弹窗 点击确认
    handleUnderstand() {
      this.dialogSignOut = !this.dialogSignOut;
      // 账号确认注销，关闭弹窗返回登录页
      this.$router.push("/login");
    },
    //返回首页
    goBack() {
      this.$router.push({
        path: "/FirmHomePage",
      });
    },
    // 获取页面卷动高度
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    routerChange(index, item) {
      this.selIndex = index;
      this.$router.push({
        path: item.url,
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/css/firmEachIndex.css";

.firm_container {
  .firm_Main_body {
    .firm-nav-table {
      display: flex;

      .nav-left {
        width: 200px;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        color: #333;
        background-color: #fff;

        .menu-box {
          .menu-title {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            background: rgba(97, 144, 232, 0.3);
            border-radius: 10px;
            font-size: 20px;
            color: #409eff ;
            margin: 10px 10px 20px;
            cursor: pointer;

            .title-img {
              margin: 2px 10px 0 0;
            }
            .title-text {
              font-size: 20px;
            }
          }

          .menu-box-item-yes {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            font-size: 16px;
            margin: 8px 10px;
            cursor: pointer;
            color: #333;
          }

          .menu-box-item-no {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #eeeeee;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            margin: 8px 10px;
            color: #409eff ;
          }
        }
      }

      .nav-right {
        flex: 1;
        background: rgba(97, 144, 232, 0.1);
        border-radius: 50px 0px 0px 50px;
      }
    }
  }
}
/deep/ .el-input__inner {
  border: 1px solid #409eff  !important ;
}
</style>
